module.exports = __webpack_public_path__ + "static/media/endosee-product-img@2x.bed5c5ad.png";